<template>
  <div class="income w-100-pct h-100-pct">
    <div class="vert w-100-pct h-100-pct bg-wt al-it-c">

      <div class="wid-dyn">
        <navbar v-bind:selindex=0></navbar>
      </div>
      <div class="vert h-100-pct just-space-between wid-dyn">
        <div class="vert just-space-around flex1 bg-p1 p-b-2v p-x-2v">
          <div class="al-l m-t-1-5v">
            <span class="f0-7 c-c2"> Desired Income </span>
              <!-- <img class="ml-auto p-2" src="../../static/circle-x.svg" v-on:click="reset" height=44em width=auto /> -->
            <div class="horiz input-row">
              <span class="c-p4 f0-7 p-x-1v">$</span>
              <formattedNumberInput ref="desiredincome" v-model="desiredIncome" @showkeypad="show_keypad()" @hidekeypad="hide_keypad()" />

              <!-- <input type="text" class="flex1 form-control" v-model="desiredIncomeFmt" @click="select_all($event)"> -->
              <div class="horiz al-it-c c-c2 tran-hover p-0-5v r1" @click="toggleIncomeTimeframe()">
                {{ incomeTimeframe }}
                <img class="m-l-0-5v h-1-5-rem" svg-inline src="@/assets/up-down.svg"/>
              </div>
            </div>
          </div>


          <div class="al-l m-t-1-5v">
            <span class="f0-7 c-c2"> Expected Social Security and Pension </span>
            <div class="horiz input-row">
              <span class="c-p4 f0-7 p-x-1v">$</span>
              <formattedNumberInput ref="socialsecurity" v-model="socialSecurity" @focus=select_input(1) @showkeypad="show_keypad()" @hidekeypad="hide_keypad()" />
              <span class="c-p4 f0-7 p-x-1v">Per Month</span>
            </div>
          </div>

          <div class="horiz just-space-around m-t-1-5v">
            <div class="al-l">
              <span class="f0-7 c-c2"> Current Age </span>
              <div class="horiz input-row wid-dyn-pair">
                <formattedNumberInput ref="currentage" v-model="currentAge" @focus="select_input(2)" @showkeypad="show_keypad()" @hidekeypad="hide_keypad()" />
                <span class="flex0 c-p4 f0-7 p-x-1v">Years</span>
              </div>
              <div class="f0-7 c-red wid-dyn-pair" :class="{hide: !isErrorCurrentAge}">
                Less than 0.
              </div>
            </div>

            <div class="al-l">
              <span class="f0-7 c-c2"> Retirement Age </span>
              <div class="horiz input-row wid-dyn-pair">
                <formattedNumberInput ref="retireage" v-model="retireAge" @focus="select_input(3)" @showkeypad="show_keypad()" @hidekeypad="hide_keypad()" />
                <!-- <input class="flex1" type="text" v-bind:class="{ 'is-invalid': isErrorRetireAge}" id="retireAge" v-model="retireAge" @click="select_all($event)"> -->
                <div class="flex0 c-p4 f0-7 p-x-1v m-l-auto">Years</div>
              </div>
              <div class="f0-7 c-red wid-dyn-pair" :class="{hide: !isErrorRetireAge || isErrorCurrentAge}" >
                Less than current age.
              </div>
            </div>
          </div>

          <div class="horiz just-space-around m-t-1-5v">
            <div class="al-l">
              <span class="f0-7 c-c2"> Return </span>
              <div class="horiz input-row wid-dyn-pair">
                <formattedNumberInput ref="returnpct" v-model="returnPct" @showkeypad="show_keypad()" @hidekeypad="hide_keypad()" />
                <!-- <input class="flex1" type="text" id="returnPct" v-model="returnPct" @click="select_all($event)"> -->
                <div class="flex0 c-p4 f0-7 p-x-1v m-l-auto m-r-0">%</div>
              </div>
              <div v-if="isErrorMinReturn" class="f0-7 c-red wid-dyn-pair">
                less than inflation or 0%
              </div>
              <div v-else :class="{hide: !isErrorMaxReturn}" class="f0-7 c-red wid-dyn-pair">
                greater than 12%
              </div>
            </div>

            <div class="al-l">
              <span class="f0-7 c-c2"> Inflation </span>
              <div class="horiz input-row wid-dyn-pair">
                <formattedNumberInput ref="inflationpct" v-model="inflationPct" @showkeypad="show_keypad()" @hidekeypad="hide_keypad()" />
                <!-- <input class="flex1" type="text" v-bind:class="{ 'is-invalid': isErrorinflation}" id="inflationPct" v-model="inflationPct" @click="select_all($event)"> -->
                <span class="flex0 c-p4 f0-7 p-x-1v">%</span>
              </div>
              <div :class="{hide: !isErrorinflation}" class="f0-7 c-red wid-dyn-pair">
                Less than 0
              </div>
            </div>
          </div>

          <div class="al-l m-t-1-5v">
            <span class="f0-7 c-c2"> Current Savings </span>
            <div class="horiz input-row">
              <span class="c-p4 f0-7 p-x-1v">$</span>
              <formattedNumberInput ref="savings" v-model="savings" @showkeypad="show_keypad()" @hidekeypad="hide_keypad()" />
              <!-- <input type="text" class="flex1 form-control" id="savings" v-model="savingsFmt" @click="select_all($event)"> -->
            </div>
          </div>


          <div class="al-l m-t-1-5v">
            <span class="c-c2"> Total dollars needed at retirement </span>
            <div class="horiz output-row">
              <span class="c-p4 p-x-1v">$</span>
              <input class="f1-5 flex1" type="text" v-model="totalvalue" readonly>
              <!-- <div style="margin-left: 5px">
                <piechart width=35px height=35px v-bind:percent="endpct"></piechart>
              </div> -->
            </div>
          </div>
        </div>

        <div class="h-25-vh">
          <clientsAIAd v-if="show_ad" />
          <numberPad v-if="show_numbers" @number_click="add_num($event)" @backspace_click="add_backspace()" @enter_click="add_enter()" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>


import { defineComponent } from '@vue/composition-api'
import navbar from './navbar.vue'
import formattedNumberInput from './FormattedNumberInput.vue'
import numberPad from './NumberPad.vue'
import ClientsAIAd from './ClientsAIAd.vue'
// import piechart from './PieChart.vue'

export default defineComponent ({
  name: 'Income',
  components: {
    navbar,
    formattedNumberInput,
    numberPad,
    ClientsAIAd,
    // piechart
  },
  data () {
    return  {
      selected_input: -1,
      desiredIncome: '100000',
      returnPct: '8',
      inflationPct: '3',
      currentAge: '40',
      retireAge: '62',
      socialSecurity: '0',
      savings: '0',
      incomeTimeframe: 'Annually',
      show_ad: true,
      show_numbers: false,
    }
  },
  methods: {
    add_backspace() {
      this.$refs.desiredincome.delete_char()
      this.$refs.socialsecurity.delete_char()
      this.$refs.currentage.delete_char()
      this.$refs.retireage.delete_char()
      this.$refs.returnpct.delete_char()
      this.$refs.inflationpct.delete_char()
      this.$refs.savings.delete_char()
    },
    show_keypad() {
      this.show_ad = false
      this.show_numbers = true
    },
    hide_keypad() {
      this.show_ad = true
      this.show_numbers = false
    },
    add_enter() {
      this.$refs.desiredincome.on_enter_key()
      this.$refs.socialsecurity.on_enter_key()
      this.$refs.currentage.on_enter_key()
      this.$refs.retireage.on_enter_key()
      this.$refs.returnpct.on_enter_key()
      this.$refs.inflationpct.on_enter_key()
      this.$refs.savings.on_enter_key()
    },
    add_num(num) {
      this.$refs.desiredincome.append_num(num)
      this.$refs.socialsecurity.append_num(num)
      this.$refs.currentage.append_num(num)
      this.$refs.retireage.append_num(num)
      this.$refs.returnpct.append_num(num)
      this.$refs.inflationpct.append_num(num)
      this.$refs.savings.append_num(num)
    },
    select_all(event) {
      event.target.select();
      this.show_numbers = true;
      this.show_ad = false;
    },
    reset () {
      this.$store.dispatch('reset')
    },
    formatNumber (newValue) {
      return newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    simpleNumber (newValue) {
      return newValue.replace(/\D/g, "")
    },
    loadAllState () {
      this.savings = this.$store.state.startAmount
      this.retireAge = this.$store.state.retireAge
      this.currentAge = this.$store.state.currentAge
      this.returnPct = this.$store.state.returnPct
      this.inflationPct = this.$store.state.inflationPct
      this.incomeTimeframe = this.$store.state.timeframe
      this.desiredIncome = this.$store.state.income
      this.socialSecurity = this.$store.state.socialSecurity
    },
    storeAllState() {
      const data = {
        savings: this.savings,
        retireAge: this.retireAge,
        currentAge: this.currentAge,
        returnPct: this.returnPct,
        inflationPct: this.inflationPct,
        timeframe: this.incomeTimeframe,
        income: this.desiredIncome,
        socialSecurity: this.socialSecurity,
      }
      this.$store.commit('UPDATE_ALL_INCOME', data)
    },
    toggleIncomeTimeframe() {
      switch (this.incomeTimeframe) {
        case 'Annually': this.incomeTimeframe = 'Monthly'; break;
        case 'Monthly': this.incomeTimeframe = 'Annually'; break;
      }
    },
  },
  created() {
    this.loadAllState()
  },
  destroyed () {
    this.storeAllState()
  },
  watch: {
    // savings: function (newvalue) {
    //   this.$store.commit('UPDATESTART', newvalue)
    // },
    resetCount: function () {
      this.loadAllState()
    },
    // retireAge: function (newValue) {
    //   if (this.$store.state.retireAge !== newValue) {
    //     this.$store.dispatch('updateRetireAge', newValue)
    //   }
    // },
    // currentAge: function (newValue) {
    //   if (this.$store.state.currentAge !== newValue) {
    //     this.$store.dispatch('updateCurAge', newValue)
    //   }
    // },
    // returnPct: function (newValue) {
    //   this.$store.dispatch('updateReturn', newValue)
    // },
    // inflationPct: function (newValue) {
    //   this.$store.dispatch('updateInflation', newValue)
    // },
    // incomeTimeframe: function (newValue) {
    //   this.$store.dispatch('updateTimeframe', newValue)
    // },
  },
  computed: {
    effectiveReturn: function () {
      return (Math.min(12, this.returnPct) - this.inflationPct)
    },
    resetCount: function () {
      return this.$store.state.resetCount
    },
    endpct: function () {
      var futureValue = (this.annualIncome - 12 * this.socialSecurity) * (Math.pow(1.0 + 0.01 * this.inflationPct, this.retireAge - this.currentAge))
      var futureSavings = this.savings * (Math.pow(1.0 + 0.01 * this.effectiveReturn, this.retireAge - this.currentAge))
      var total=(futureValue / (0.01 * this.effectiveReturn))
      return Math.max(0, Math.min(0.999, futureSavings/total))
    },
    totalvalue: function () {
      var futureValue = Math.max(0, (this.annualIncome - 12 * this.socialSecurity) * (Math.pow(1.0 + 0.01 * this.inflationPct, this.retireAge - this.currentAge)))
      if (this.effectiveReturn > 0) {
        var result = (futureValue / (0.01 * this.effectiveReturn)).toFixed(0)
        this.$store.dispatch('update_end', result)
        return this.formatNumber(result)
      } else {
        return ''
      }
    },
    annualIncome: function () {
      switch (this.incomeTimeframe) {
        case "Annually": return this.desiredIncome;
        case "Monthly": return 12*this.desiredIncome;
      }
      return this.desiredIncome
    },
    isErrorMinReturn: function () {
      var isnumeric = !isNaN(parseFloat(this.returnPct)) && isFinite(this.returnPct)
      return (!isnumeric || (parseFloat(this.returnPct) < parseFloat(this.inflationPct)) || (parseFloat(this.returnPct) < 0))
    },
    isErrorMaxReturn: function () {
      var isnumeric = !isNaN(parseFloat(this.returnPct)) && isFinite(this.returnPct)
      return (!isnumeric || (parseFloat(this.returnPct) > 12))
    },
    isErrorinflation: function () {
      var isnumeric = !isNaN(parseFloat(this.inflationPct)) && isFinite(this.inflationPct)
      return (!isnumeric || (parseFloat(this.inflationPct) < 0))
    },
    isErrorCurrentAge: function () {
      var isnumeric = !isNaN(parseFloat(this.currentAge)) && isFinite(this.currentAge)
      return (!isnumeric || (parseFloat(this.currentAge) < 0))
    },
    isErrorRetireAge: function () {
      var isnumeric = !isNaN(parseFloat(this.currentAge)) && isFinite(this.retireAge)
      return (!isnumeric || (parseFloat(this.retireAge) < 0) || (parseFloat(this.retireAge) < this.currentAge))
    }
  }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-left {
  text-align: left
}
.result {
  background-color: #ffffe0
}
input {
  text-align: center
}
.lightbox {
  background-color: #f7f8f9;
  border-radius: 0.5em
}
.calcbutton {
  background-color: #e9ecef;
  border-color: #ced4da;
}
.fullwidth {
  width: 100%
}
label {
  margin-top: 0.5em
}
input:invalid {
  border: 5px solid #ffdddd
}
.tran-hover:hover {
  background-color: #c0c0c040;
  box-shadow: var(--button-shadow);
}
.button {
  /* width: min(23vw, 9vh); */
  margin-top: auto;
  margin-bottom: auto;
  width: 100%;
  height: 100%;
  font-size: min(6vw, 4vh);
  line-height: min(8vw, 6vh);
}
.hide {
  opacity: 0;
}

</style>

